import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserProfileService } from '@ui-app/services/user-profile.service';
import { RoutesConfig } from '@employee-configs/routes.config';
@Injectable({
    providedIn: 'root'
})
export class ConditionalRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private userProfileService: UserProfileService
    ) {
    }
    canActivate(): boolean {
        const user = this.userProfileService.user;
        
        if (user && user.country === 'USI') {
            this.router.navigate([RoutesConfig.pages.employeeBadgeRequestPage]);
        } else {
            this.router.navigate([RoutesConfig.pages.badgeRequests]);
        }
        
        return false;
    }
}